import { FC } from "react";
import "./ChatHighlightModal.scss";
import { Modal } from "react-bootstrap";
import { useChatHighlights } from "../../../providers/ChatHighlights/ChatHighlightsProvider";

const ChatHighlightModal: FC = () => {
  const { currentHighlight, showHighlightModal, handleCloseModal } =
    useChatHighlights();

  if (!showHighlightModal || !currentHighlight) return null;

  const isLoom = currentHighlight.media_type === "loom";
  const isYoutube = currentHighlight.media_type === "youtube";
  const isVideo = currentHighlight.media_type === "video";
  const baseUrl = (process.env.REACT_APP_BEVIAJUDA_API || "").replace(/\/$/, "");
  const mediaUrl = currentHighlight.filename ? `${baseUrl}/${currentHighlight.filename}` : "";

  // O backend pode devolver embed_url pronto (igual já faz pro Loom) ou só o link cru em
  // external_url — nesse caso extraímos o ID aqui pra montar o embed mesmo assim.
  const youtubeEmbedUrl = (() => {
    if (!isYoutube) return "";
    if (currentHighlight.embed_url) return currentHighlight.embed_url;
    const raw = currentHighlight.external_url ?? "";
    try {
      const u = new URL(raw);
      const host = u.hostname.replace(/^www\.|^m\./, "");
      let id: string | null = null;
      if (host === "youtu.be") id = u.pathname.slice(1).split("/")[0] || null;
      else if (host === "youtube.com") {
        if (u.pathname === "/watch") id = u.searchParams.get("v");
        else if (u.pathname.startsWith("/embed/")) id = u.pathname.split("/embed/")[1]?.split("/")[0] || null;
        else if (u.pathname.startsWith("/shorts/")) id = u.pathname.split("/shorts/")[1]?.split("/")[0] || null;
      }
      return id ? `https://www.youtube.com/embed/${id}` : "";
    } catch {
      return "";
    }
  })();

  return (
    <Modal
      show={showHighlightModal}
      onHide={handleCloseModal}
      centered
      className="ChatHighlightModal"
      size="lg"
      backdrop="static"
    >
      <Modal.Body className="chat-highlight-modal__body">
        <div className="chat-highlight-modal__header">
          <h2 className="chat-highlight-modal__title">
            {currentHighlight.title}
          </h2>
          <button
            type="button"
            className="chat-highlight-modal__close"
            aria-label="Fechar"
            onClick={handleCloseModal}
          >
            ×
          </button>
        </div>

        {currentHighlight.description && (
          <p className="chat-highlight-modal__description">
            {currentHighlight.description}
          </p>
        )}

        <div className="chat-highlight-modal__media">
          {isLoom ? (
            <iframe
              src={`${currentHighlight.embed_url}?hideEmbedTopBar=true`}
              frameBorder="0"
              allowFullScreen
              style={{
                width: "100%",
                aspectRatio: "16/9",
              }}
            />
          ) : isYoutube ? (
            <iframe
              src={youtubeEmbedUrl}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                width: "100%",
                aspectRatio: "16/9",
              }}
            />
          ) : isVideo ? (
            <video
              key={currentHighlight.id}
              controls
              className="chat-highlight-modal__video"
            >
              <source src={mediaUrl} type="video/mp4" />
              Seu navegador não suporta a reprodução de vídeo.
            </video>
          ) : (
            <img
              src={mediaUrl}
              alt={currentHighlight.title}
              className="chat-highlight-modal__image"
            />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ChatHighlightModal;
